import { useState } from 'react';
import { Report } from 'interfaces';
import { MRT_Row } from 'mantine-react-table';
//Sentry
import { Flex, Button, Loader, Tooltip } from '@mantine/core';
import { IconDownload } from '@tabler/icons-react';
import { useDownloadFromS3 } from 'hooks';

interface ReportDownloadButtonProps {
  row?: MRT_Row<Report>;
  s3Path?: string;
  tipText?: string | undefined;
}
const bucket = `report-files-${import.meta.env.VITE_ACCOUNT_ID}`;

export const ReportDownloadButton = ({
  row,
  s3Path,
  tipText = undefined,
}: ReportDownloadButtonProps) => {
  const [urlLoading, setUrlLoading] = useState(false);
  const tipDisabled = row ? !!row.original.s3Path : !!s3Path;
  const key = row
    ? encodeURIComponent(row.original.s3Path)
    : encodeURIComponent(s3Path);
  const downloadFile = useDownloadFromS3(bucket, key, setUrlLoading);
  return (
    <Flex justify={'flex-start'} direction={'row'} gap={'md'}>
      <Tooltip
        label={!!tipText && tipDisabled ? tipText : 'Report not available yet'}
        position="top"
        withArrow
        transitionProps={{ duration: 500, transition: 'fade-up' }}
        disabled={tipDisabled && !tipText}
      >
        <Button
          variant="outline"
          onClick={downloadFile}
          disabled={row ? !row.original.s3Path : !s3Path}
          data-testid="report-download-button"
        >
          {urlLoading ? <Loader size={20} /> : <IconDownload size={20} />}
        </Button>
      </Tooltip>
    </Flex>
  );
};
